var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-wrap",class:_vm.width},[_c('div',{staticClass:"view"},[_c('section',[_c('div',{staticClass:"section-inner"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"full"},[_vm._t("full")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }